import { viteAppBaseUrl } from '@/constants/env';
import { FF_C4C_IMMEDIATE_NURSE_CONSULTATION_V2, FF_C4C_RECORD_VOICE_CALL } from '@/constants/featureFlags';
import settings from '@/data/constants';
import { useFeatureFlags } from '@/hooks';
import { usePatientPhoneNumber } from '@/hooks/usePatientPhoneNumber';
import { AmazonConnectCcpProvider, ConfigProvider as TelecomConfigProvider } from '@montugroup/clinic-telecom';
import type { ReactNode } from 'react';

export type AmazonConnectProviderProps = {
  children: ReactNode;
};

// TODO: [B2C-8488] Remove immediate nurse consultation logic
export const AmazonConnectProvider = ({ children }: AmazonConnectProviderProps) => {
  const { flags } = useFeatureFlags();
  const ffRecordVoiceCall = flags[FF_C4C_RECORD_VOICE_CALL];
  const ffImmediateNurseConsultationV2 = flags[FF_C4C_IMMEDIATE_NURSE_CONSULTATION_V2];
  const { shouldDisplayPatientPhoneNumber } = usePatientPhoneNumber();
  const baseUrl = viteAppBaseUrl();

  if (!ffImmediateNurseConsultationV2) {
    return children;
  }

  return (
    <TelecomConfigProvider baseUrl={baseUrl}>
      <AmazonConnectCcpProvider
        ccpUrl={settings.connect.ccpInstanceUrl}
        loginUrl={settings.connect.samlLoginUrl}
        supportUrl={settings.serviceDeskUrl}
        canRecordCalls={ffRecordVoiceCall}
        shouldDisplayPatientPhoneNumber={shouldDisplayPatientPhoneNumber}
      >
        {children}
      </AmazonConnectCcpProvider>
    </TelecomConfigProvider>
  );
};
